import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Checkbox } from 'rmwc/Checkbox';
import { List, ListItem, ListItemText, ListItemSecondaryText, ListItemMeta } from 'rmwc';
import { Text } from '../../components/Text';
import Hint from '../../components/ModuleDrawer/Hint';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { backOnboarding, continueOnboarding, pathAware } from '../../actions/onboardingActions';

const savingsAccountTypes = [
  {
    type: 'normal',
    label: 'Normal Retirement Accounts',
    text: 'Traditional 401(k) | Traditional IRA | 403(b) | 457(b)',
  },
  {
    type: 'roth',
    label: 'Roth Retirement Accounts',
    text: 'Roth 401(k) | Roth IRA',
  },
  {
    type: 'education',
    label: 'Education Savings Accounts',
    text: '529 College Savings Plan | Coverdell ESA',
  },
  {
    type: 'regular',
    label: 'Regular Accounts (No Special Tax Treatment)',
    text: 'Bank Accounts | Online Brokerage Account',
  },
];

class SavingsAccountTypes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountTypes: props.qna_hash.accountTypes ? props.qna_hash.accountTypes.answer : [],
    };
  }

  componentDidMount() {
    this.props.pathAware('accountTypes');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.accountTypes) {
      this.setState({
        accountTypes: props.qna_hash.accountTypes.answer,
      });
    }
  }

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;

    this.props
      .continueOnboarding(qna_stack, qna_hash, {
        accountTypes: {
          question: 'What kind of savings accounts to you have?',
          answer: this.state.accountTypes,
        },
      })
      .then(onContinue);
  };

  _canContinue = () => !!this.state.accountTypes.length;

  _onBack = () => {
    this.props.backOnboarding(this.props.qna_stack).then(() => this.props.onBack());
  };

  onChange = (evt, field) => {
    let accountTypes = this.state.accountTypes.slice();

    if (accountTypes.includes(field)) {
      accountTypes = accountTypes.filter(item => item !== field);
    } else {
      accountTypes.push(field);
    }

    this.setState({ accountTypes });
  };

  checkboxRow = option => {
    const selected = this.state.accountTypes.includes(option.type);

    return (
      <ListItem
        id={option.type}
        theme={selected && 'secondary'}
        key={option.type}
        selected={selected}
        onClick={e => this.onChange(e, option.type)}
      >
        <ListItemText>
          {option.label}
          <ListItemSecondaryText>{option.text}</ListItemSecondaryText>
        </ListItemText>
        <ListItemMeta theme={selected && 'secondary'} className="hrbr-clickable">
          {selected ? 'check_box' : 'check_box_outline_blank'}
        </ListItemMeta>
      </ListItem>
    );
  };

  render() {
    const { qna_hash, wrapper } = this.props;

    return (
      <DynamicWrapper
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue={this._canContinue()}
        helperText={<Hint>Don't worry about getting it perfect! You'll be able to update this information later.</Hint>}
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">What kind of savings accounts do you have?</Text>
        </div>
        <div
          style={{ width: '90%', margin: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
        >
          <Text className="mb-0" use="body1">
            Please check any option that applies. If you're not sure, it's okay to leave it blank.
          </Text>
        </div>
        <List twoLine>{savingsAccountTypes.map(this.checkboxRow)}</List>
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, continueOnboarding, pathAware })(SavingsAccountTypes);
